import { gql } from "graphql-tag";

import UserBookStatusFragment from "./UserBookStatusFragment";

export default gql(UserBookStatusFragment);
